type Props = {
	title: string
	description: string
	number: number
}

function HighlightsItem({
	title,
	description,
	number,
}: Props) {

	return (
		<div className="flex flex-col text-sm sm:text-base text-black">
			<div className="font-bold">
				{ `${ number }. ${ title }` }
			</div>
			<div className="font-normal">
				{ description }
			</div>
		</div>
	);
}

export default HighlightsItem;